module.exports = "<p>\n  article-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/library-assets/article-list/article-list.component.html
// module id = ./src/app/library-assets/article-list/article-list.component.html
// module chunks = main